import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { FadeIn } from '@shared/animations/animations';
import { AnalysisService } from '@shared/services/analysis.service';

@Component({
	selector: 'dd-open-analyze',
	templateUrl: './open-analyze.component.html',
	styles: [`
		::ng-deep .p-card-content { padding:0 }
		::ng-deep .p-divider .p-divider-content {
			background: #f7f5f3
		}
		
		::ng-deep body, ::ng-deep html {
			background: #043c53 !important;
		}
		
		::ng-deep .description h2 { font-weight:500; }
		::ng-deep .description h2,
		::ng-deep .description h6 {
			font-family: 'Bree Serif',Georgia,"Times New Roman",serif;
			margin-bottom:15px;
		}
		::ng-deep .description h6 { font-size: 20px;    font-family: 'League Spartan'; }
	`],
	animations: [FadeIn]
})
export class OpenAnalyzeComponent implements OnInit {

	isLoading: boolean = false;
	analyzeID: number = 0;
	analyze: any;
	isSurvey: boolean = false;
	isCharts: boolean = false;
	courseID: number = 0;

	constructor(private analysisService: AnalysisService, private route: ActivatedRoute, private router: Router) {
	}

	ngOnInit(): void {

		this.isLoading = true;
		this.router.events.subscribe((evt) => {
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			window.scrollTo(0, 0)
		});

		this.route.paramMap.subscribe(params => {
			this.analyzeID = +params.get('analyzeID');
			this.isSurvey = false;


			if(params.get('courseID')) {
				this.courseID = +params.get('courseID');
				this.isSurvey = true;
			}


			this.analysisService.fetchPublicAnalyses(this.analyzeID).then(() => {
				this.analysisService.analysis$.subscribe((analyses:any) => {
					if(analyses) {
						this.analyze = analyses.find((x: any) => x.analyzeID == this.analyzeID);
						this.isCharts = this.analyze?.resultType == 'charts';
					}

					this.isLoading = false;
					//console.error(this.analyze);
				})
			});

		});
	}

}
